import script from "./TagInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TagInput.vue?vue&type=script&setup=true&lang=js"

import "./TagInput.vue?vue&type=style&index=0&id=56e81dd5&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e81dd5"]])

export default __exports__